import type { ChangeEvent, ReactNode } from 'react';

import { Z_INDEX } from '@/config/z-index';
import { BaseDialog } from '@/shared/ui/overlays/Modal/BaseDialog';
import ShareDialogContent from './ShareDialogContent';

const ShareDialog = ({
  open,
  onClose,
  content,
  emailError,
  handleChangeRecipient,
  header,
  recipient,
  shareUrl,
  onContentChange,
  onCopyClick,
  onSendEmail,
  enableSendEmail = true,
  renderLinkSection
}: {
  open: boolean;
  onClose: () => void;
  content: string;
  emailError: string;
  handleChangeRecipient: (recipient: string) => void;
  header: ReactNode;
  recipient: string;
  shareUrl?: string;
  onContentChange: (content: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onCopyClick?: () => void;
  onSendEmail: () => void;
  enableSendEmail?: boolean;
  renderLinkSection?: ReactNode;
}) => {
  return (
    <BaseDialog
      open={open}
      sx={{ zIndex: Z_INDEX.priority }}
      onClose={onClose}
    >
      <ShareDialogContent
        content={content}
        emailError={emailError}
        enableSendEmail={enableSendEmail}
        handleChangeRecipient={e => {
          handleChangeRecipient(e.target.value);
        }}
        header={header}
        recipient={recipient}
        renderLinkSection={renderLinkSection}
        shareUrl={shareUrl}
        onContentChange={onContentChange}
        {...(onCopyClick && { onCopyClick })}
        onSendEmail={onSendEmail}
      />
    </BaseDialog>
  );
};

export default ShareDialog;
